import React from 'react';
import { img_path } from '../../../environment';

const ImageWithBasePath = (props) => {
  const { src, className, height, width, alt, id } = props;

  // If src is undefined/null or not a string, use fallback image
  if (!src || typeof src !== 'string') {
    console.warn('ImageWithBasePath: Invalid src ->', src); 
    return (
      <img
        className={className}
        src="/default-thumbnail.png" // 🔁 fallback image
        height={height}
        width={width}
        alt={alt || 'default'}
        id={id}
      />
    );
  }

  const fullSrc = src.startsWith('https') ? src : `${img_path}${src}`;

  return (
    <img
      className={className}
      src={fullSrc}
      height={height}
      width={width}
      alt={alt}
      id={id}
    />
  );
};

export default ImageWithBasePath;
